import useCraftFilterHook from "./use-craft-filter-hook";


const CraftHooks = {
    useFilter : useCraftFilterHook
};

export default CraftHooks;